import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { userRequest } from "../../utils/requestMethods";
import { useStateContext } from "../../contexts/ContextProvider";
import { AddStaffModal, EditStaffNameModal, StaffTable } from "../../components";

const AdminManagement = () => {
  const history = useHistory();
  const { school } = useStateContext();
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAdmin, setEditingAdmin] = useState(null);
  const schoolId = school?._id;

  const fetchAdmins = async () => {
    if (schoolId) {
      try {
        setLoading(true);
        const { data } = await userRequest.get(`/schools/${schoolId}/admins?limit=100`);
        setAdmins(data.users);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, [schoolId]);

  const handleDelete = async (adminId) => {
    try {
      await userRequest.delete(`/schools/${schoolId}/remove-staff/${adminId}`);
      fetchAdmins();
    } catch (error) {
      console.log(error);
    }
  };

  const handleViewDetails = (admin) => {
    history.push(`/management/admin/${admin._id}`, { admin });
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <StaffTable
        data={admins}
        loading={loading}
        onDelete={handleDelete}
        onEdit={setEditingAdmin}
        onViewDetails={handleViewDetails}
        title="Admin Management"
        onAddNew={toggleModal}
        addButtonText="Add New Admin"
        editActionLabel="Edit Admin"
      />

      {isModalOpen && (
        <AddStaffModal
          onClose={toggleModal}
          schoolId={schoolId}
          onStaffAdded={fetchAdmins}
          role="burser"
          roleOptions={["burser", "academic_admin"]}
        />
      )}

      {editingAdmin && (
        <EditStaffNameModal
          onClose={() => setEditingAdmin(null)}
          schoolId={schoolId}
          staff={editingAdmin}
          onUpdated={fetchAdmins}
          roleOptions={["burser", "academic_admin"]}
          title="Edit Admin"
        />
      )}
    </>
  );
};

export default AdminManagement;
